export default "__VITE_ASSET__DnQ2fr1L__"